<script setup lang="ts">
import { capitalize } from 'vue'

export interface CenteredModalProps {
  isOpen?: boolean
  modalClass?: string
  kind?: 'default' | 'styleless'
}

const { isOpen, modalClass, kind = 'default' } = defineProps<CenteredModalProps>()

const emit = defineEmits<{ close: [] }>()

const onBackdropClick = () => {
  emit('close')
}
</script>

<template>
  <Transition
    :enterActiveClass="$style.blurEnterActive"
    :leaveActiveClass="$style.blurLeaveActive"
    :enterFromClass="$style.blurEnterFrom"
    :leaveToClass="$style.blurLeaveTo"
  >
    <div v-if="isOpen" :class="$style.backdrop" @click="onBackdropClick" />
  </Transition>

  <Transition
    :enterActiveClass="$style.appearEnterActive"
    :leaveActiveClass="$style.appearLeaveActive"
    :enterFromClass="$style.appearEnterFrom"
    :leaveToClass="$style.appearLeaveTo"
  >
    <div v-if="isOpen" :class="$style.modalWrap">
      <div :class="[$style.modal, $style[`modal${capitalize(kind)}`], modalClass]"><slot /></div>
    </div>
  </Transition>
</template>

<style lang="scss" module>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
  z-index: var(--sc-z-index-modal-backdrop);
}

.blurEnterActive,
.blurLeaveActive {
  transition: backdrop-filter 0.3s;
}

.blurEnterFrom,
.blurLeaveTo {
  backdrop-filter: blur(0);
}

.modalWrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--sc-z-index-modal);
  pointer-events: none;
}

.modal {
  width: fit-content;
  position: fixed;
  pointer-events: all;
}

.modalDefault {
  max-width: calc(100vw - 40px);
  background-color: #303035;
  border-radius: 4px;
}

.appearEnterActive,
.appearLeaveActive {
  transition:
    opacity 0.4s,
    transform 0.4s;
}

.appearEnterFrom,
.appearLeaveTo {
  opacity: 0;
  transform: scale(0.9);
}
</style>
